/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { JobId } from "../../commons/types/JobId";
import { RunbookId } from "../../commons/types/RunbookId";
export const CaptureRoutineJobConfig = core.serialization.object({
    sourceJobId: JobId,
    runbookId: RunbookId,
});
